import {Skeleton, Box, Typography} from '@mui/material';

const ChequeRegisterSkeleton = () => {
    return (
        <div>
            <Skeleton variant="text" width="100%" height={30} />
            <Skeleton variant="text" width="60%" height={30} />

            <Typography
                sx={{fontSize: '13px', marginTop: '16px', marginBottom: '8px'}}
                className="primaryColorLight-900"
            >
                <Skeleton variant="text" width="80%" />
            </Typography>

            <Box
                sx={{
                    background: '#fff',
                    border: 'dashed 1px #D7DBEC',
                    padding: '30px',
                    borderRadius: '2px',
                    marginTop: '16px',
                }}
            >
                <Skeleton variant="text" width="50%" height={30} />
                <Skeleton
                    variant="rectangular"
                    width="100%"
                    height={50}
                    sx={{marginTop: '16px'}}
                />

                <Skeleton
                    variant="text"
                    width="50%"
                    height={30}
                    sx={{marginTop: '16px'}}
                />
                <Skeleton
                    variant="rectangular"
                    width="100%"
                    height={50}
                    sx={{marginTop: '16px'}}
                />

                <Skeleton
                    variant="text"
                    width="50%"
                    height={30}
                    sx={{marginTop: '16px'}}
                />
                <Skeleton
                    variant="rectangular"
                    width="100%"
                    height={50}
                    sx={{marginTop: '16px'}}
                />
            </Box>

            <Skeleton
                variant="text"
                width="100%"
                height={30}
                sx={{marginTop: '16px', marginBottom: '8px'}}
            />

            <Skeleton
                variant="rectangular"
                width="100%"
                height={56}
                sx={{marginTop: '8px'}}
            />
            <Skeleton
                variant="rectangular"
                width="100%"
                height={56}
                sx={{marginTop: '16px'}}
            />
        </div>
    );
};

export default ChequeRegisterSkeleton;
